import React, { useEffect, useState } from 'react';
import GridLayout from "react-grid-layout";
import { ContextMenu, MenuItem, ContextMenuTrigger } from "react-contextmenu";
import { useNavigate } from 'react-router-dom';
import { get } from '../../Services/Api.service';
import { useDataTransform } from '../../Services/useDataTransform';


export const BlockPage = () => {

    const title = "Main page blocks";
    const [blocks, setBlocks] = useState(null);
    const [toggle, setToggle] = useState(false);

    useEffect(() => {
        get('/api/adminportal/settings/Blocks').then(resp => resp.json()).then((resp) => {
            const result = resp && resp.map(({ blockViewModel }) => blockViewModel);
            setBlocks(result);
        });

    }, [])
    const history = useNavigate();

    const createPage = () => history(`/Local_Campaign/create`);
    const editPage = (id, systemId) => () => history(`/LocalCampaign/edit/${systemId}`);
    const deletePage = (systemId) => () => setBlocks(prev => prev.filter(item => item.systemId !== systemId));
    const addBlock = (block) => () => setBlocks(prev => ([...prev, block]));
    const save = () => { alert('Error: No endpoints for saving Blocks. Data is not saved') };

    return <>
        <div className="row page-header">
            <div className="columns small-6">
                <h1 className="page__title">{title}</h1>
            </div>
            <div className="columns small-3 dropdown">
            </div>
            <div className="columns small-3">
                <button onClick={() => save} disabled className="button large expanded">Save</button>
            </div>
        </div>
        {blocks && blocks.length ?
            <GridLayout className="blockPage__layout backend__table" cols={1} rowHeight={70} width={10000}>
                {blocks.map((block, index) => <div key={block.systemId} className='blockPage__block' data-grid={{ x: 0, y: 0, w: 1, h: 2 }}>
                    <div className='gridster__block'>{block.templateId}{block.templateId === "LocalCampaign" ? <i className='edit' onClick={editPage(block.id, block.systemId)}></i> : null}{block.deleteEndpoint ? <i className='delete' onClick={deletePage(block.id)}></i> : null}</div>
                </div>)}
            </GridLayout>
            : <h1 className='row page-notify'>
                No blocks on this page
            </h1>}
    </>
}


